import { Box } from '@chakra-ui/react';
import WholesalerField from '@/components/pickers/WholesalerField';
import PartnerCompanyField from '@/components/pickers/PartnerCompanyField';
import CarrierField from '@/components/pickers/CarrierField';
import PublicPoolField from '../formFields/PublicPoolField';
import GlobalEntityField from '../formFields/GlobalEntityField';
import PortingTypeField from '../formFields/PortingTypeField';
import NotesField from '../formFields/NotesField';
import AddCustomFields from '../formFields/AddCustomFields';
import AddBlockTable from '../table/AddBlockTable';
import walkthroughIds from '../../walkthroughIds';

const {
    ufPublicPoolCheckbox,
    ufGlobalEntityCheckbox,
    ufWholesalerSelect,
    ufNumBlockPortingType,
    ufCustomAttribute,
    ufNotesComment,
} = walkthroughIds;

export default function AddBlockContent({
    // Formik render props
    values,
    setFieldValue,
    errors,
    touched,
    // Business context
    darkMode,
    requiredScope,
    handleFieldValueChange,
    onError,
    onCarriersLoaded,
    // Table state
    aggregateTable,
    updateAggregateTable,
    hasError,
    setHasError,
    hasEmptyNumber,
    setHasEmptyNumber,
    // Upload method (2264/2319)
    uploadMethod,
    setUploadMethod,
    isCreateOrderWholesaler,
    // Country validation (2267)
    countryMismatchRows,
}) {
    return [
        {
            label: 'Details',
            content: (
                <>
                    {requiredScope >= 80 && (
                        <WholesalerField
                            darkMode={darkMode}
                            values={values}
                            setFieldValue={(field, value) => {
                                setFieldValue(field, value);
                                handleFieldValueChange(field, value);
                            }}
                            errors={errors}
                            touched={touched}
                            ufWholesalerSelect={ufWholesalerSelect}
                            requiredScope={requiredScope}
                        />
                    )}

                    {requiredScope > 40 && (
                        <PartnerCompanyField
                            darkMode={darkMode}
                            values={values}
                            setFieldValue={(field, value) => {
                                setFieldValue(field, value);
                                if (
                                    field === 'partnerID' ||
                                    field === 'companyID' ||
                                    field === 'companyIsTrial'
                                ) {
                                    handleFieldValueChange(field, value);
                                }
                            }}
                            errors={errors}
                            touched={touched}
                            mode="partner"
                            label="Partner"
                            description="Select the partner for this number block."
                        />
                    )}

                    <PartnerCompanyField
                        darkMode={darkMode}
                        values={values}
                        setFieldValue={(field, value) => {
                            setFieldValue(field, value);
                            if (
                                field === 'partnerID' ||
                                field === 'companyID' ||
                                field === 'companyIsTrial'
                            ) {
                                handleFieldValueChange(field, value);
                            }
                        }}
                        errors={errors}
                        touched={touched}
                        mode="company"
                        label="Company"
                        description="Select the company for this number block."
                    />

                    <CarrierField
                        darkMode={darkMode}
                        values={values}
                        setFieldValue={(field, value) => {
                            setFieldValue(field, value);
                            handleFieldValueChange(field, value);
                        }}
                        errors={errors}
                        touched={touched}
                        requiredScope={requiredScope}
                        onCarriersLoaded={onCarriersLoaded}
                    />

                    <PublicPoolField
                        darkMode={darkMode}
                        values={values}
                        setFieldValue={setFieldValue}
                        ufPublicPoolCheckbox={ufPublicPoolCheckbox}
                    />

                    {requiredScope >= 80 && (
                        <GlobalEntityField
                            darkMode={darkMode}
                            values={values}
                            setFieldValue={setFieldValue}
                            ufGlobalEntityCheckbox={ufGlobalEntityCheckbox}
                        />
                    )}

                    <PortingTypeField
                        darkMode={darkMode}
                        values={values}
                        setFieldValue={setFieldValue}
                        errors={errors}
                        touched={touched}
                        ufNumBlockPortingType={ufNumBlockPortingType}
                        onError={onError}
                    />

                    <NotesField
                        darkMode={darkMode}
                        values={values}
                        setFieldValue={setFieldValue}
                        ufNotesComment={ufNotesComment}
                        requiredScope={requiredScope}
                    />

                    <Box>
                        <AddBlockTable
                            aggregateTable={aggregateTable}
                            updateAggregateTable={updateAggregateTable}
                            hasError={hasError}
                            setHasError={setHasError}
                            hasEmptyNumber={hasEmptyNumber}
                            setHasEmptyNumber={setHasEmptyNumber}
                            companyIsTrial={values.companyIsTrial}
                            uploadMethod={uploadMethod}
                            setUploadMethod={setUploadMethod}
                            isCreateOrderWholesaler={isCreateOrderWholesaler}
                            usage={values.usage}
                            setFieldValue={setFieldValue}
                            handleFieldValueChange={handleFieldValueChange}
                            countryMismatchRows={countryMismatchRows}
                        />
                    </Box>
                </>
            ),
        },
        {
            label: 'Custom',
            content: (
                <AddCustomFields
                    darkMode={darkMode}
                    errors={errors}
                    touched={touched}
                    ufCustomAttribute={ufCustomAttribute}
                />
            ),
        },
    ];
}
